import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useMe } from "@repo/shared/components";
import dayjs from "dayjs";
import { useTranslation } from "next-i18next";

import { ProjectAllTimeSummary } from "./ProjectAllTimeSummary";
import { ProjectWorktimeOverview } from "./ProjectWorktimeOverview";
import { ProjectWorktimeYearOverview } from "./ProjectWorktimeYearOverview";

export const Dashboard = () => {
	const { t, i18n } = useTranslation();

	const contact = useMe();

	const today = dayjs().locale(i18n.language).format("dddd, D MMMM");

	const typeOfDay = () => {
		const morning = dayjs().hour(11).minute(31);
		const noon = dayjs().hour(14).minute(1);
		const afterNoon = dayjs().hour(17).minute(1);
		return dayjs().isBefore(morning)
			? "morning"
			: dayjs().isBefore(noon)
				? "noon"
				: dayjs().isBefore(afterNoon)
					? "afternoon"
					: "evening";
	};

	let welcomeMessage = t(`dashboard.${typeOfDay()}`);

	welcomeMessage += `, ${contact.firstName}`;

	const theme = useTheme();

	return (
		<Box
			className="pagePadding"
			style={{
				margin: "-" + theme.spacing(1),
				top: theme.spacing(9),
			}}>
			<Box style={{ position: "relative" }}>
				<div
					style={{
						opacity: 0.6,
					}}
					className="contentCenter">
					{today}
				</div>
				<h1 className="contentCenter purpleHeader">{welcomeMessage}</h1>
			</Box>
			<Box style={{ height: "450px" }} className="paddingBottom40" display="flex" gap={2}>
				<Box style={{ height: "100%" }} flex={1}>
					<ProjectWorktimeOverview />
				</Box>
				<Box style={{ height: "100%" }} flex={1}>
					<ProjectWorktimeYearOverview />
				</Box>
			</Box>
			<hr className="w-100" style={{ marginBottom: 20 }} />
			<Box sx={{ mt: 2.5, mb: 6 }}>
				<ProjectAllTimeSummary />
			</Box>
		</Box>
	);
};
